import React, { useState, useEffect } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import {
  Card,
  Row,
  Col,
  Button,
  Badge,
  Table,
  Spinner,
  Alert,
  Modal,
  Form,
  InputGroup,
  Tabs,
  Tab,
  ListGroup,
  ProgressBar,
  Toast,
  ToastContainer,
  Dropdown,
  Pagination
} from "react-bootstrap";
import axios from "axios";
import {
  ArrowLeft,
  Pencil,
  Trash,
  CheckCircle,
  XCircle,
  ExclamationCircle,
  Tag,
  List,
  Folder,
  PlusCircle,
  Search,
  People,
  FileText,
  Calendar,
  Clock,
  Check,
  X,
  Eye,
  Save,
  GraphUp,
  Cash,
  Percent,
  Gear,
  ArrowRepeat,
  Activity,
  CreditCard,
  Receipt,
  ClockHistory,
  ExclamationTriangle,
  Person,
  ArrowRight,
  Wallet,
  
  TrendingDown,
  InfoCircle,
  ShieldCheck,
  Bank,
  Briefcase,
  Layers,
  Star,
  StarFill
} from "react-bootstrap-icons";

const API_BASE_URL = process.env.NODE_ENV === 'development' 
  ? '' 
  : process.env.REACT_APP_API_URL;
const defaultCurrency = sessionStorage.getItem("default_currency") || 'XOF';
const TAXES_ENDPOINT = `${API_BASE_URL}/taxes`;
const CATEGORIES_ENDPOINT = `${API_BASE_URL}/taxes-categories`;
const CONTRIBUABLES_ENDPOINT = `${API_BASE_URL}/taxpayers`;
const TERMS_ENDPOINT = `${API_BASE_URL}/terms`;
const PAYMENTS_ENDPOINT = `${API_BASE_URL}/payments`;
const USAGER_CATEGORIES_ENDPOINT = `${API_BASE_URL}/activites`;

export default function CategoryDetails() {
  const navigate = useNavigate();
  const { id } = useParams();

  // États principaux
  const [category, setCategory] = useState(null);
  const [taxes, setTaxes] = useState([]);
  const [contribuables, setContribuables] = useState([]);
  const [allTaxes, setAllTaxes] = useState([]);
  const [allTerms, setAllTerms] = useState([]);
  const [allPayments, setAllPayments] = useState([]);
  const [activities, setActivities] = useState([]);
  const [usagerCategories, setUsagerCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState("overview");
  const [refreshing, setRefreshing] = useState(false);

  // États pour les modals
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showAddTaxModal, setShowAddTaxModal] = useState(false);
  const [editedCategory, setEditedCategory] = useState(null);
  
  // États pour les chargements
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [loadingAddTax, setLoadingAddTax] = useState(false);
  const [loadingContribuables, setLoadingContribuables] = useState(false);
  const [loadingActivities, setLoadingActivities] = useState(false);
  const [loadingUsagerCategories, setLoadingUsagerCategories] = useState(false);

  // États pour les notifications
  const [alertMessage, setAlertMessage] = useState({ show: false, message: '', type: 'info' });

  // États pour les filtres
  const [taxFilterText, setTaxFilterText] = useState('');
  const [taxStatusFilter, setTaxStatusFilter] = useState('all');
  const [contribuableFilterText, setContribuableFilterText] = useState('');
  const [contribuableStatusFilter, setContribuableStatusFilter] = useState('all');
  const [activityFilter, setActivityFilter] = useState('all');
  const [activityPage, setActivityPage] = useState(1);
  const activitiesPerPage = 10;

  // États pour les activités professionnelles
  const [professionnelActivities, setProfessionnelActivities] = useState([]);
  const [professionnelFilterText, setProfessionnelFilterText] = useState('');
  const [professionnelCurrentPage, setProfessionnelCurrentPage] = useState(1);
  const professionnelActivitiesPerPage = 12;

  // États pour la pagination
  const [taxCurrentPage, setTaxCurrentPage] = useState(1);
  const [contribuableCurrentPage, setContribuableCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // États pour le formulaire de nouvelle taxe
  const [newTax, setNewTax] = useState({
    tax_category: "",
    titre: "",
    description: "",
    montant: "",
    frequence: "annual",
    actif: true
  });

  const frequencies = {
    annual: "Annuelle",
    weekly: "Hebdomadaire",
    monthly: "Mensuelle",
    quarterly: "Trimestrielle",
    semiannual: "Semestrielle",
    daily: "Journalière",
    one_off: "Unique"
  };

  const frequencyIcons = {
    annual: "",
    monthly: "",
    quarterly: "",
    semiannual: "",
    weekly: "",
    daily: "",
    one_off: "s"
  };

  const getHeaders = () => {
    const token = sessionStorage.getItem("authToken");
    return {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    };
  };

  const showAlert = (message, type = 'info', duration = 4000) => {
    setAlertMessage({ show: true, message, type });
    if (duration > 0) {
      setTimeout(() => setAlertMessage(prev => ({ ...prev, show: false })), duration);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', {
      day: '2-digit', month: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit'
    });
  };

  const formatCurrency = (amount) => {
    const numAmount = parseFloat(amount) || 0;
    return numAmount.toLocaleString('fr-FR', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }) + ' ' + defaultCurrency;
  };

  const formatNumber = (num) => {
    return new Intl.NumberFormat('fr-FR').format(num || 0);
  };

  const formatRelativeTime = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);
    
    if (diffMins < 1) return "À l'instant";
    if (diffMins < 60) return `Il y a ${diffMins} minute${diffMins > 1 ? 's' : ''}`;
    if (diffHours < 24) return `Il y a ${diffHours} heure${diffHours > 1 ? 's' : ''}`;
    if (diffDays < 7) return `Il y a ${diffDays} jour${diffDays > 1 ? 's' : ''}`;
    return formatDate(dateString);
  };

  // Chargement des données
  const loadUsagerCategories = async () => {
    try {
      setLoadingUsagerCategories(true);
      const response = await axios.get(USAGER_CATEGORIES_ENDPOINT, getHeaders());
      if (response.data && Array.isArray(response.data)) {
        setUsagerCategories(response.data);
        
      }
    } catch (err) {
      console.error("Erreur chargement catégories d'usagers:", err);
    } finally {
      setLoadingUsagerCategories(false);
    }
  };

  const loadCategoryData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${CATEGORIES_ENDPOINT}/${id}`, getHeaders());
      setCategory(response.data.data || response.data);
      setEditedCategory(response.data.data || response.data);
    } catch (err) {
      console.error("Erreur chargement catégorie:", err);
      setError("Erreur lors du chargement de la catégorie");
      showAlert("Erreur lors du chargement", "danger");
    } finally {
      setLoading(false);
    }
  };

  const loadAllTaxes = async () => {
    try {
      const response = await axios.get(TAXES_ENDPOINT, getHeaders());
      const taxesData = response.data.data || [];
      setAllTaxes(taxesData);
      
      const filtered = taxesData.filter(tax => parseInt(tax.tax_category) === parseInt(id));
      setTaxes(filtered);
    } catch (err) {
      console.error("Erreur chargement taxes:", err);
      setAllTaxes([]);
      setTaxes([]);
    }
  };

  const loadAllTerms = async () => {
    try {
      const response = await axios.get(TERMS_ENDPOINT, getHeaders());
      const termsData = response.data.echeances || response.data.data || [];
      setAllTerms(termsData);
      
      if (termsData.length > 0) {
        await loadAllContribuables();
        buildActivities();
      }
    } catch (err) {
      console.error("Erreur chargement échéances:", err);
      setAllTerms([]);
    }
  };

  const loadAllPayments = async () => {
    try {
      const response = await axios.get(PAYMENTS_ENDPOINT, getHeaders());
      const paymentsData = response.data.paiements || response.data.data || [];
      setAllPayments(paymentsData);
    } catch (err) {
      console.error("Erreur chargement paiements:", err);
      setAllPayments([]);
    }
  };

  const loadAllContribuables = async () => {
    try {
      setLoadingContribuables(true);
      
      const taxesDeCetteCategorie = allTaxes.filter(
        tax => parseInt(tax.tax_category) === parseInt(id)
      ).map(tax => tax.taxe_id);
      
      const echeancesConcernantCetteCategorie = allTerms.filter(term => 
        taxesDeCetteCategorie.includes(term.taxe_id)
      );
      
      const contribuablesMap = new Map();
      
      echeancesConcernantCetteCategorie.forEach(term => {
        if (term.contribuable && term.contribuable.contribuable_id) {
          const contribuableId = term.contribuable.contribuable_id;
          if (!contribuablesMap.has(contribuableId)) {
            contribuablesMap.set(contribuableId, {
              ...term.contribuable,
              echeances: [],
              taxes_ids: new Set()
            });
          }
          
          const contribuable = contribuablesMap.get(contribuableId);
          contribuable.echeances.push(term);
          contribuable.taxes_ids.add(term.taxe_id);
        }
      });
      
      const contribuablesAvecStats = Array.from(contribuablesMap.values()).map(contribuable => {
        const echeancesDuContribuable = contribuable.echeances;
        const taxesIds = Array.from(contribuable.taxes_ids);
        
        const taxesDeCetteCategoriePourCeContribuable = taxesIds.filter(id => 
          taxesDeCetteCategorie.includes(id)
        ).length;
        
        const montantTotal = echeancesDuContribuable.reduce(
          (sum, term) => sum + (parseFloat(term.montant_initial) || 0), 0
        );
        
        const montantPaye = echeancesDuContribuable.reduce(
          (sum, term) => sum + (parseFloat(term.montant_paye) || 0), 0
        );
        
        return {
          ...contribuable,
          nombre_taxes_categorie: taxesDeCetteCategoriePourCeContribuable,
          nombre_echeances: echeancesDuContribuable.length,
          montant_total_categorie: montantTotal,
          montant_paye_categorie: montantPaye,
          montant_restant_categorie: montantTotal - montantPaye,
          taux_paiement: montantTotal > 0 ? (montantPaye / montantTotal) * 100 : 0
        };
      });
      
      setContribuables(contribuablesAvecStats);
      
    } catch (err) {
      console.error("Erreur traitement contribuables:", err);
      setContribuables([]);
    } finally {
      setLoadingContribuables(false);
    }
  };

const buildProfessionnelActivities = () => {
  if (contribuables.length === 0 || usagerCategories.length === 0) {
    console.log("⏳ Données manquantes - Contribuables:", contribuables.length, "Catégories:", usagerCategories.length);
    return;
  }

  console.log("🏗️ Construction des activités avec:");
  console.log("  - Contribuables:", contribuables.length);
  console.log("  - usagerCategories:", usagerCategories.map(c => ({ 
    id_export: c.id_export, 
    type: typeof c.id_export, 
    name: c.name 
  })));

  const activitiesMap = new Map();

  contribuables.forEach(contribuable => {
    let codeActivite = contribuable.activite_contribuable || 
                      contribuable.apiData?.activite_contribuable || 
                      contribuable.code_activite;
    
    if (!codeActivite) return;

    // Convertir en nombre pour la comparaison
    const codeNum = typeof codeActivite === 'string' ? parseInt(codeActivite, 10) : Number(codeActivite);
    
    console.log(`🔍 Traitement code activité: ${codeActivite} -> ${codeNum}`);
    
    // Recherche avec conversion des types
    const category = usagerCategories.find(c => {
      const cIdExport = typeof c.id_export === 'string' ? parseInt(c.id_export, 10) : Number(c.id_export);
      return cIdExport === codeNum;
    });
    
    const nomActivite = category?.name || category?.cat_name || `Activité ${codeActivite}`;
    const description = category?.description || '';

    console.log(`  → ${codeActivite} -> ${nomActivite} ${category ? '✅' : '❌'}`);

    if (!activitiesMap.has(codeActivite)) {
      activitiesMap.set(codeActivite, {
        code: codeActivite,
        nom: nomActivite,
        name: nomActivite,
        description: description,
        category: category,
        contribuables: [],
        nombreContribuables: 0,
        montantTotal: 0,
        montantPaye: 0,
        nombreEcheances: 0,
        taxesLiees: new Set()
      });
    }

    const activityData = activitiesMap.get(codeActivite);
    activityData.contribuables.push(contribuable);
    activityData.nombreContribuables++;
    activityData.montantTotal += contribuable.montant_total_categorie || 0;
    activityData.montantPaye += contribuable.montant_paye_categorie || 0;
    activityData.nombreEcheances += contribuable.nombre_echeances || 0;
    
    if (contribuable.taxes_ids) {
      contribuable.taxes_ids.forEach(taxeId => activityData.taxesLiees.add(taxeId));
    }
  });

  const activitiesArray = Array.from(activitiesMap.values()).map(activity => ({
    ...activity,
    taxesLiees: Array.from(activity.taxesLiees),
    nombreTaxes: activity.taxesLiees.size,
    tauxPaiement: activity.montantTotal > 0 
      ? (activity.montantPaye / activity.montantTotal) * 100 
      : 0
  })).sort((a, b) => (a.nom || '').localeCompare(b.nom || ''));

  console.log("✅ Activités construites:", activitiesArray.length);
  console.log("📊 Détail:", activitiesArray.map(a => ({ code: a.code, nom: a.nom, nb: a.nombreContribuables })));
  
  setProfessionnelActivities(activitiesArray);
};

useEffect(() => {
  console.log("=== CONTENU DE usagerCategories ===");
  console.log("Nombre d'activités:", usagerCategories.length);
  console.log("Première activité:", usagerCategories[0]);
  console.log("Toutes les activités:", usagerCategories);
}, [usagerCategories]);


  const buildActivities = () => {
    setLoadingActivities(true);
    
    try {
      const taxesDeCetteCategorie = allTaxes.filter(
        tax => parseInt(tax.tax_category) === parseInt(id)
      ).map(tax => tax.taxe_id);
      
      const echeancesConcernantCetteCategorie = allTerms.filter(term => 
        taxesDeCetteCategorie.includes(term.taxe_id)
      );
      
      const echeancesActivities = echeancesConcernantCetteCategorie.map(term => {
        const montantInitial = parseFloat(term.montant_initial) || 0;
        const montantPaye = parseFloat(term.montant_paye) || 0;
        const montantRestant = montantInitial - montantPaye;
        
        let type = 'echeance';
        let title = 'Échéance créée';
        let color = 'primary';
        let icon = Receipt;
        
        if (term.statut === 'payee' || (montantPaye >= montantInitial && montantInitial > 0)) {
          type = 'paiement';
          title = 'Paiement effectué';
          color = 'success';
          icon = CheckCircle;
        } else if (term.statut === 'expiree' || (term.date_echeance && new Date(term.date_echeance) < new Date() && montantPaye === 0)) {
          type = 'alerte';
          title = 'Échéance expirée';
          color = 'danger';
          icon = XCircle;
        } else if (montantPaye > 0 && montantPaye < montantInitial) {
          type = 'alerte';
          title = 'Paiement partiel';
          color = 'warning';
          icon = ExclamationTriangle;
        }
        
        return {
          id: `term-${term.id}`,
          date: term.date_echeance || term.created_at,
          type: type,
          title: title,
          description: `${term.taxe?.titre || 'Taxe'} - Période: ${term.periode || ''}`,
          montant: montantInitial,
          montantPaye: montantPaye,
          reste: montantRestant,
          contribuable: term.contribuable,
          taxe: term.taxe,
          reference: term.reference,
          color: color,
          icon: icon,
          badges: [
            { bg: 'info', text: term.taxe?.frequence || 'Mensuel' },
            term.date_echeance ? { bg: 'light', text: `Échéance: ${formatDate(term.date_echeance)}` } : null
          ].filter(Boolean)
        };
      });
      
      const paymentsActivities = [];
      if (allPayments.length > 0) {
        allPayments.forEach(payment => {
          const taxeConcernee = allTaxes.find(t => t.taxe_id === payment.taxe_id);
          if (taxeConcernee && taxesDeCetteCategorie.includes(payment.taxe_id)) {
            paymentsActivities.push({
              id: `payment-${payment.id}`,
              date: payment.date_paiement,
              type: 'paiement',
              title: 'Paiement reçu',
              description: `${payment.taxe?.titre || 'Paiement'} - ${payment.reference_paiement}`,
              montant: parseFloat(payment.montant) || 0,
              contribuable: payment.contribuable,
              taxe: payment.taxe,
              reference: payment.reference_paiement,
              methode: payment.methode,
              color: 'success',
              icon: CheckCircle,
              badges: [
                payment.methode ? { bg: 'info', text: payment.methode } : null,
                payment.payment_bank ? { bg: 'secondary', text: payment.payment_bank } : null
              ].filter(Boolean)
            });
          }
        });
      }
      
      const allActivities = [...echeancesActivities, ...paymentsActivities]
        .sort((a, b) => new Date(b.date) - new Date(a.date));
      
      setActivities(allActivities);
      
    } catch (err) {
      console.error("Erreur construction activités:", err);
      setActivities([]);
    } finally {
      setLoadingActivities(false);
    }
  };

  useEffect(() => {
    if (id) {
      loadCategoryData();
      loadAllTaxes();
      loadAllTerms();
      loadAllPayments();
      loadUsagerCategories();
    }
  }, [id]);

  useEffect(() => {
    if (allTerms.length > 0 && allTaxes.length > 0) {
      buildActivities();
    }
  }, [allTerms, allTaxes, allPayments]);

  useEffect(() => {
    if (allTerms.length > 0 && allTaxes.length > 0 && id) {
      loadAllContribuables();
    }
  }, [allTerms, allTaxes, id]);

  useEffect(() => {
    if (contribuables.length > 0 && usagerCategories.length > 0) {
      buildProfessionnelActivities();
    }
  }, [contribuables, usagerCategories]);

  const handleRefresh = async () => {
    setRefreshing(true);
    await loadCategoryData();
    await loadAllTaxes();
    await loadAllTerms();
    await loadAllPayments();
    await loadUsagerCategories();
    setRefreshing(false);
    showAlert("Données actualisées avec succès", "success");
  };

  const handleSaveEdit = async () => {
    if (!editedCategory?.category_name?.trim()) {
      showAlert("Le nom de la catégorie est requis", "warning");
      return;
    }

    setLoadingUpdate(true);
    try {
      await axios.put(
        `${CATEGORIES_ENDPOINT}/${id}`,
        {
          category_name: editedCategory.category_name,
          category_descr: editedCategory.category_descr
        },
        getHeaders()
      );

      setCategory(editedCategory);
      setShowEditModal(false);
      showAlert("Catégorie modifiée avec succès", "success");
    } catch (err) {
      console.error("Erreur modification:", err);
      showAlert("Erreur lors de la modification", "danger");
    } finally {
      setLoadingUpdate(false);
    }
  };

  const handleDelete = async () => {
    setLoadingDelete(true);
    try {
      await axios.delete(`${CATEGORIES_ENDPOINT}/${id}`, getHeaders());
      showAlert("Catégorie supprimée avec succès", "success");
      setTimeout(() => navigate('/admin/CategoriesTaxes'), 2000);
    } catch (err) {
      console.error("Erreur suppression:", err);
      showAlert("Erreur lors de la suppression", "danger");
    } finally {
      setLoadingDelete(false);
    }
  };

  const handleAddTax = async () => {
    try {
      setLoadingAddTax(true);
      
      if (!newTax.titre || newTax.titre.trim() === "") {
        showAlert("Veuillez saisir un titre pour la taxe", "warning");
        return;
      }
      
      if (!newTax.montant || parseFloat(newTax.montant) <= 0) {
        showAlert("Veuillez saisir un montant valide", "warning");
        return;
      }

      const payload = {
        ...newTax,
        tax_category: id,
        montant: Number(newTax.montant),
        currency: defaultCurrency
      };

      await axios.post(TAXES_ENDPOINT, payload, getHeaders());

      showAlert("Taxe créée avec succès", "success");
      setShowAddTaxModal(false);
      
      setNewTax({
        tax_category: "",
        titre: "",
        description: "",
        montant: "",
        frequence: "annual",
        actif: true
      });

      await loadAllTaxes();

    } catch (err) {
      console.error("Erreur création taxe:", err);
      showAlert(err.response?.data?.message || "Erreur lors de la création de la taxe", "danger");
    } finally {
      setLoadingAddTax(false);
    }
  };

  // Calculs des statistiques
  const stats = {
    totalTaxes: taxes.length,
    activesTaxes: taxes.filter(t => t.actif === 1).length,
    inactivesTaxes: taxes.filter(t => t.actif !== 1).length,
    montantTotal: taxes.reduce((sum, t) => sum + (parseFloat(t.montant) || 0), 0),
    montantMoyen: taxes.length > 0 ? taxes.reduce((sum, t) => sum + (parseFloat(t.montant) || 0), 0) / taxes.length : 0,
    totalContribuables: contribuables.length,
    totalActivites: activities.length,
    totalProfessionnelActivities: professionnelActivities.length,
    montantTotalContribuables: contribuables.reduce((sum, c) => sum + (c.montant_total_categorie || 0), 0),
    montantPayeContribuables: contribuables.reduce((sum, c) => sum + (c.montant_paye_categorie || 0), 0),
    tauxRecouvrementGlobal: contribuables.reduce((sum, c) => sum + (c.montant_total_categorie || 0), 0) > 0
      ? (contribuables.reduce((sum, c) => sum + (c.montant_paye_categorie || 0), 0) / contribuables.reduce((sum, c) => sum + (c.montant_total_categorie || 0), 0)) * 100
      : 0
  };

  // Filtrage
  const filteredTaxes = taxes.filter(t => {
    const matchesSearch = t.titre?.toLowerCase().includes(taxFilterText.toLowerCase()) ||
      t.description?.toLowerCase().includes(taxFilterText.toLowerCase());
    const matchesStatus = taxStatusFilter === 'all' ||
      (taxStatusFilter === 'active' && t.actif === 1) ||
      (taxStatusFilter === 'inactive' && t.actif !== 1);
    return matchesSearch && matchesStatus;
  });

  const filteredContribuables = contribuables.filter(c => {
    const matchesSearch = c.nom_contribuable?.toLowerCase().includes(contribuableFilterText.toLowerCase()) ||
      c.email?.toLowerCase().includes(contribuableFilterText.toLowerCase()) ||
      c.telephone?.includes(contribuableFilterText);
    const matchesStatus = contribuableStatusFilter === 'all' ||
      (contribuableStatusFilter === 'active' && c.is_active === 1) ||
      (contribuableStatusFilter === 'inactive' && c.is_active !== 1);
    return matchesSearch && matchesStatus;
  });

  const filteredActivities = activities.filter(activity => 
    activityFilter === 'all' || activity.type === activityFilter
  );

  const filteredProfessionnelActivities = professionnelActivities.filter(activity => 
    activity.nom.toLowerCase().includes(professionnelFilterText.toLowerCase()) ||
    activity.code?.toString().toLowerCase().includes(professionnelFilterText.toLowerCase()) ||
    activity.description?.toLowerCase().includes(professionnelFilterText.toLowerCase())
  );

  // Pagination
  const taxTotalPages = Math.ceil(filteredTaxes.length / itemsPerPage);
  const taxStartIndex = (taxCurrentPage - 1) * itemsPerPage;
  const paginatedTaxes = filteredTaxes.slice(taxStartIndex, taxStartIndex + itemsPerPage);

  const contribuableTotalPages = Math.ceil(filteredContribuables.length / itemsPerPage);
  const contribuableStartIndex = (contribuableCurrentPage - 1) * itemsPerPage;
  const paginatedContribuables = filteredContribuables.slice(contribuableStartIndex, contribuableStartIndex + itemsPerPage);

  const activityTotalPages = Math.ceil(filteredActivities.length / activitiesPerPage);
  const activityStartIndex = (activityPage - 1) * activitiesPerPage;
  const paginatedActivities = filteredActivities.slice(activityStartIndex, activityStartIndex + activitiesPerPage);

  const professionnelTotalPages = Math.ceil(filteredProfessionnelActivities.length / professionnelActivitiesPerPage);
  const professionnelStartIndex = (professionnelCurrentPage - 1) * professionnelActivitiesPerPage;
  const paginatedProfessionnelActivities = filteredProfessionnelActivities.slice(
    professionnelStartIndex, 
    professionnelStartIndex + professionnelActivitiesPerPage
  );

const getActivityName = (code) => {
  if (!code) return 'Non spécifiée';
  
  // Convertir en nombre pour la comparaison
  const codeNum = typeof code === 'string' ? parseInt(code, 10) : Number(code);
  
  console.log(`🔍 Recherche activité pour code:`, code, 'converti en:', codeNum);
  console.log(`📦 usagerCategories disponibles:`, usagerCategories.map(c => ({ id_export: c.id_export, type: typeof c.id_export, name: c.name })));
  
  // Chercher dans usagerCategories
  const category = usagerCategories.find(c => {
    const cIdExport = typeof c.id_export === 'string' ? parseInt(c.id_export, 10) : Number(c.id_export);
    return cIdExport === codeNum;
  });
  
  if (category) {
    console.log(`✅ Trouvé: ${category.name}`);
    return category.name || category.cat_name || `Activité ${code}`;
  }
  
  console.log(`❌ Non trouvé pour code ${code}`);
  return `Activité ${code}`;
};
  const getRecoveryVariant = (taux) => {
    if (taux >= 75) return "success";
    if (taux >= 50) return "info";
    if (taux >= 25) return "warning";
    return "danger";
  };

  if (loading) {
    return (
      <>
        <Header />
        <div className="main main-app p-4 d-flex align-items-center justify-content-center" style={{ minHeight: '80vh' }}>
          <div className="text-center">
            <div className="spinner-border text-primary mb-3" style={{ width: '3rem', height: '3rem' }} />
            <h5>Chargement de la catégorie</h5>
            <p className="text-muted">Veuillez patienter...</p>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  if (error || !category) {
    return (
      <>
        <Header />
        <div className="main main-app p-4">
          <Alert variant="danger" className="text-center py-5">
            <ExclamationCircle size={48} className="mb-3" />
            <h4>Erreur</h4>
            <p>{error || "Catégorie non trouvée"}</p>
            <Button variant="primary" onClick={() => navigate('/admin/CategoriesTaxes')} className="mt-3">
              <ArrowLeft className="me-2" /> Retour à la liste
            </Button>
          </Alert>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />

      <ToastContainer className="p-3" style={{ zIndex: 9999, position: 'fixed', top: '20px', right: '20px' }}>
        <Toast
          show={alertMessage.show}
          onClose={() => setAlertMessage({ ...alertMessage, show: false })}
          bg={alertMessage.type}
          delay={4000}
          autohide
        >
          <Toast.Header closeButton={false}>
            {alertMessage.type === 'success' && <CheckCircle className="me-2" />}
            {alertMessage.type === 'danger' && <XCircle className="me-2" />}
            {alertMessage.type === 'warning' && <ExclamationCircle className="me-2" />}
            <strong className="me-auto">Notification</strong>
          </Toast.Header>
          <Toast.Body className="text-white">{alertMessage.message}</Toast.Body>
        </Toast>
      </ToastContainer>

      <div className="main main-app p-4" style={{ background: '#f0f2f5' }}>
        <div className="container-fluid">
          {/* En-tête */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <Button 
                variant="link" 
                className="p-0 text-decoration-none mb-2 d-flex align-items-center text-muted"
                onClick={() => navigate('/admin/CategoriesTaxes')}
              >
                <ArrowLeft className="me-1" size={16} />
                Retour aux catégories
              </Button>
              <h2 className="display-7 fw-bold mb-1 d-flex align-items-center gap-3">
                {category.category_name}
                <Badge bg="primary" className="fs-6 px-3 py-2">
                  <Tag className="me-1" size={14} />
                  ID: {category.category_id || category.id}
                </Badge>
              </h2>
              <p className="text-muted mb-0">
                <Calendar className="me-1" size={14} />
                Créée le {formatDate(category.created_at)}
              </p>
            </div>
            <div className="d-flex gap-2">
              <Button variant="light" onClick={handleRefresh} disabled={refreshing}>
                <ArrowRepeat className={`me-2 ${refreshing ? 'spin' : ''}`} size={16} />
                Actualiser
              </Button>
              <Button variant="outline-primary" onClick={() => setShowEditModal(true)}>
                <Pencil className="me-2" size={16} />
                Modifier
              </Button>
              <Button variant="success" onClick={() => setShowAddTaxModal(true)}>
                <PlusCircle className="me-2" size={16} />
                Nouvelle taxe
              </Button>
            </div>
          </div>

          {/* Description */}
          {category.category_descr && (
            <Card className="border-0 shadow-sm mb-4">
              <Card.Body className="py-3">
                <div className="d-flex align-items-center">
                  <FileText className="text-primary me-2" size={20} />
                  <span className="text-muted">{category.category_descr}</span>
                </div>
              </Card.Body>
            </Card>
          )}

          {/* Cartes de statistiques */}
          <Row className="g-4 mb-4">
            <Col lg={3} md={6}>
              <Card className="border-0 shadow-sm h-100 stats-card">
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-start mb-3">
                    <div>
                      <p className="text-muted text-uppercase small fw-semibold mb-1">Taxes</p>
                      <h2 className="fw-bold mb-0">{formatNumber(stats.totalTaxes)}</h2>
                    </div>
                    <div className="bg-primary bg-opacity-10 p-3 rounded-circle">
                      <Receipt className="text-primary" size={24} />
                    </div>
                  </div>
                  <div className="d-flex gap-3">
                    <div>
                      <Badge bg="success" pill className="px-2 py-1">
                        {stats.activesTaxes} actives
                      </Badge>
                    </div>
                    <div>
                      <Badge bg="secondary" pill className="px-2 py-1">
                        {stats.inactivesTaxes} inactives
                      </Badge>
                    </div>
                  </div>
                  <ProgressBar 
                    now={(stats.activesTaxes / (stats.totalTaxes || 1)) * 100} 
                    variant="primary" 
                    className="mt-3"
                    style={{ height: '4px' }}
                  />
                </Card.Body>
              </Card>
            </Col>

            <Col lg={3} md={6}>
              <Card className="border-0 shadow-sm h-100 stats-card">
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-start mb-3">
                    <div>
                      <p className="text-muted text-uppercase small fw-semibold mb-1">Montant total</p>
                      <h4 className="fw-bold mb-0">{formatCurrency(stats.montantTotal)}</h4>
                    </div>
                    <div className="bg-success bg-opacity-10 p-3 rounded-circle">
                      <Cash className="text-success" size={24} />
                    </div>
                  </div>
                  <small className="text-muted">
                    Moyenne: {formatCurrency(stats.montantMoyen)} par taxe
                  </small>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={3} md={6}>
              <Card className="border-0 shadow-sm h-100 stats-card">
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-start mb-3">
                    <div>
                      <p className="text-muted text-uppercase small fw-semibold mb-1">Contribuables</p>
                      <h2 className="fw-bold mb-0">{formatNumber(stats.totalContribuables)}</h2>
                    </div>
                    <div className="bg-info bg-opacity-10 p-3 rounded-circle">
                      <People className="text-info" size={24} />
                    </div>
                  </div>
                  <small className="text-muted">
                    <Wallet className="me-1" size={12} />
                    Total dû: {formatCurrency(stats.montantTotalContribuables)}
                  </small>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={3} md={6}>
              <Card className="border-0 shadow-sm h-100 stats-card">
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-start mb-3">
                    <div>
                      <p className="text-muted text-uppercase small fw-semibold mb-1">Recouvrement</p>
                      <h2 className="fw-bold mb-0">{stats.tauxRecouvrementGlobal.toFixed(1)}%</h2>
                    </div>
                    <div className="bg-warning bg-opacity-10 p-3 rounded-circle">
                      <GraphUp className="text-warning" size={24} />
                    </div>
                  </div>
                  <ProgressBar 
                    now={stats.tauxRecouvrementGlobal} 
                    variant={getRecoveryVariant(stats.tauxRecouvrementGlobal)} 
                    className="mt-2"
                    style={{ height: '6px', borderRadius: '3px' }}
                  />
                  <small className="text-muted mt-2 d-block">
                    {formatCurrency(stats.montantPayeContribuables)} encaissés
                  </small>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Tabs */}
          <Card className="border-0 shadow-sm">
            <Card.Header className="bg-white border-bottom p-0">
              <Tabs
                activeKey={activeTab}
                onSelect={(k) => setActiveTab(k)}
                className="px-4 pt-3"
              >
                <Tab 
                  eventKey="overview" 
                  title={
                    <span>
                      <InfoCircle className="me-2" size={16} />
                      Aperçu
                    </span>
                  }
                >
                  <div className="p-4">
                    <Row>
                      <Col md={6}>
                        <h6 className="fw-semibold mb-3">Informations générales</h6>
                        <ListGroup variant="flush" className="border-0">
                          <ListGroup.Item className="d-flex justify-content-between align-items-center px-0 py-3 border-bottom bg-transparent">
                            <span className="text-muted">Nom de la catégorie</span>
                            <span className="fw-semibold">{category.category_name}</span>
                          </ListGroup.Item>
                          <ListGroup.Item className="d-flex justify-content-between align-items-center px-0 py-3 border-bottom bg-transparent">
                            <span className="text-muted">ID</span>
                            <Badge bg="light" text="dark" className="px-3 py-2">
                              {category.category_id || category.id}
                            </Badge>
                          </ListGroup.Item>
                          <ListGroup.Item className="d-flex justify-content-between align-items-center px-0 py-3 border-bottom bg-transparent">
                            <span className="text-muted">Créée le</span>
                            <span className="fw-semibold">{formatDate(category.created_at)}</span>
                          </ListGroup.Item>
                          <ListGroup.Item className="d-flex justify-content-between align-items-center px-0 py-3 bg-transparent">
                            <span className="text-muted">Dernière modification</span>
                            <span className="fw-semibold">{formatDate(category.updated_at)}</span>
                          </ListGroup.Item>
                        </ListGroup>
                      </Col>
                      <Col md={6}>
                        <h6 className="fw-semibold mb-3">Statistiques clés</h6>
                        <Row className="g-3">
                          <Col sm={6}>
                            <div className="bg-light p-3 rounded-3 text-center">
                              <List className="text-primary mb-2" size={24} />
                              <h4 className="mb-0">{formatNumber(stats.totalTaxes)}</h4>
                              <small className="text-muted">Taxes</small>
                            </div>
                          </Col>
                          <Col sm={6}>
                            <div className="bg-light p-3 rounded-3 text-center">
                              <People className="text-success mb-2" size={24} />
                              <h4 className="mb-0">{formatNumber(stats.totalContribuables)}</h4>
                              <small className="text-muted">Contribuables</small>
                            </div>
                          </Col>
                          <Col sm={6}>
                            <div className="bg-light p-3 rounded-3 text-center">
                              <Cash className="text-warning mb-2" size={24} />
                              <h5 className="mb-0">{formatCurrency(stats.montantTotal)}</h5>
                              <small className="text-muted">Montant total</small>
                            </div>
                          </Col>
                          <Col sm={6}>
                            <div className="bg-light p-3 rounded-3 text-center">
                              <Percent className="text-info mb-2" size={24} />
                              <h4 className="mb-0">{stats.tauxRecouvrementGlobal.toFixed(1)}%</h4>
                              <small className="text-muted">Recouvrement</small>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                </Tab>

                <Tab 
                  eventKey="taxes" 
                  title={
                    <span>
                      <List className="me-2" size={16} />
                      Taxes ({filteredTaxes.length})
                    </span>
                  }
                >
                  <div className="p-4">
                    <div className="d-flex justify-content-between gap-3 mb-4">
                      <InputGroup style={{ maxWidth: '400px' }}>
                        <InputGroup.Text><Search size={16} /></InputGroup.Text>
                        <Form.Control
                          placeholder="Rechercher une taxe..."
                          value={taxFilterText}
                          onChange={(e) => setTaxFilterText(e.target.value)}
                        />
                      </InputGroup>
                      <Form.Select
                        style={{ width: '180px' }}
                        value={taxStatusFilter}
                        onChange={(e) => setTaxStatusFilter(e.target.value)}
                      >
                        <option value="all">Tous les statuts</option>
                        <option value="active">Actives</option>
                        <option value="inactive">Inactives</option>
                      </Form.Select>
                    </div>

                    {filteredTaxes.length === 0 ? (
                      <div className="text-center py-5">
                        <Receipt size={48} className="text-muted mb-3 opacity-25" />
                        <h5>Aucune taxe trouvée</h5>
                        <p className="text-muted mb-4">
                          {taxFilterText ? "Aucune taxe ne correspond à votre recherche" : "Cette catégorie n'a pas encore de taxes"}
                        </p>
                        <Button variant="primary" onClick={() => setShowAddTaxModal(true)}>
                          <PlusCircle className="me-2" /> Ajouter une taxe
                        </Button>
                      </div>
                    ) : (
                      <>
                        <div className="table-responsive">
                          <Table hover className="align-middle">
                            <thead className="table-light">
                              <tr>
                                <th>ID</th>
                                <th>Titre</th>
                                <th>Description</th>
                                {/* <th>Montant</th> */}
                                <th>Fréquence</th>
                                <th>Statut</th>
                                <th>Créée le</th>
                              </tr>
                            </thead>
                            <tbody>
                              {paginatedTaxes.map(tax => (
                                <tr key={tax.taxe_id || tax.id}>
                                  <td>
                                    <Badge bg="light" text="dark" className="fw-semibold px-3 py-2">
                                      {tax.taxe_id || tax.id}
                                    </Badge>
                                  </td>
                                  <td>
                                    <div className="fw-semibold">{tax.titre}</div>
                                  </td>
                                  <td>
                                    <small className="text-muted">
                                      {tax.description?.substring(0, 50)}
                                      {tax.description?.length > 50 ? '...' : (tax.description || '-')}
                                    </small>
                                  </td>
                                  {/* <td>
                                    <span className="fw-bold text-success">
                                      {formatCurrency(tax.montant)}
                                    </span>
                                  </td> */}
                                  <td>
                                    <Badge bg="info" pill className="px-3 py-2">
                                      {frequencyIcons[tax.frequence]} {frequencies[tax.frequence] || tax.frequence}
                                    </Badge>
                                  </td>
                                  <td>
                                    {tax.actif === 1 ? (
                                      <Badge bg="success" pill className="px-3 py-2">
                                        <CheckCircle className="me-1" size={12} /> Active
                                      </Badge>
                                    ) : (
                                      <Badge bg="secondary" pill className="px-3 py-2">
                                        <XCircle className="me-1" size={12} /> Inactive
                                      </Badge>
                                    )}
                                  </td>
                                  <td>
                                    <small className="text-muted">{formatDate(tax.created_at)}</small>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>

                        {taxTotalPages > 1 && (
                          <div className="d-flex justify-content-center mt-4">
                            <Pagination size="sm">
                              <Pagination.Prev disabled={taxCurrentPage === 1} onClick={() => setTaxCurrentPage(p => p - 1)} />
                              {[...Array(Math.min(5, taxTotalPages))].map((_, i) => {
                                let pageNum = i + 1;
                                if (taxCurrentPage > 3 && taxTotalPages > 5) {
                                  pageNum = taxCurrentPage - 2 + i;
                                  if (pageNum > taxTotalPages) return null;
                                }
                                return (
                                  <Pagination.Item key={pageNum} active={pageNum === taxCurrentPage} onClick={() => setTaxCurrentPage(pageNum)}>
                                    {pageNum}
                                  </Pagination.Item>
                                );
                              })}
                              <Pagination.Next disabled={taxCurrentPage === taxTotalPages} onClick={() => setTaxCurrentPage(p => p + 1)} />
                            </Pagination>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </Tab>

                <Tab 
                  eventKey="contribuables" 
                  title={
                    <span>
                      <People className="me-2" size={16} />
                      Contribuables ({filteredContribuables.length})
                    </span>
                  }
                >
                  <div className="p-4">
                    <div className="d-flex gap-3 mb-4">
                      <InputGroup style={{ maxWidth: '400px' }}>
                        <InputGroup.Text><Search size={16} /></InputGroup.Text>
                        <Form.Control
                          placeholder="Rechercher un contribuable..."
                          value={contribuableFilterText}
                          onChange={(e) => setContribuableFilterText(e.target.value)}
                        />
                      </InputGroup>
                      <Form.Select
                        style={{ width: '150px' }}
                        value={contribuableStatusFilter}
                        onChange={(e) => setContribuableStatusFilter(e.target.value)}
                      >
                        <option value="all">Tous</option>
                        <option value="active">Actifs</option>
                        <option value="inactive">Inactifs</option>
                      </Form.Select>
                    </div>

                    {loadingContribuables ? (
                      <div className="text-center py-5">
                        <Spinner animation="border" variant="primary" />
                        <p className="mt-3 text-muted">Chargement des contribuables...</p>
                      </div>
                    ) : filteredContribuables.length === 0 ? (
                      <div className="text-center py-5">
                        <People size={48} className="text-muted mb-3 opacity-25" />
                        <h5>Aucun contribuable trouvé</h5>
                        <p className="text-muted">
                          {contribuableFilterText ? "Aucun contribuable ne correspond à votre recherche" : "Aucun contribuable n'a de taxes de cette catégorie"}
                        </p>
                      </div>
                    ) : (
                      <>
                        <div className="table-responsive">
                          <Table hover className="align-middle">
                            <thead className="table-light">
                              <tr>
                                <th>ID</th>
                                <th>Nom</th>
                                <th>Activité</th>
                                <th className="text-center">Taxes</th>
                                <th className="text-center">Échéances</th>
                                <th>Montant total</th>
                                <th>Payé</th>
                                <th className="text-center">Taux</th>
                                {/* <th>Statut</th> */}
                              </tr>
                            </thead>
                            <tbody>
                              {paginatedContribuables.map(c => (
                                <tr 
                                  key={c.contribuable_id || c.id} 
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => navigate(`/agent/ContribuableDetails/${c.contribuable_id || c.id}`)}
                                >
                                  <td>
                                    <Badge bg="light" text="dark" className="fw-semibold px-3 py-2">
                                      {c.contribuable_id || c.id}
                                    </Badge>
                                  </td>
                                  <td>
                                    <div className="fw-semibold">{c.nom_contribuable}</div>
                                  </td>
                                  <td>
                                   <Badge bg="info" pill className="px-3 py-2">
  {(() => {
    const code = c.activite_contribuable;
    if (!code) return '-';
    const codeNum = parseInt(code, 10);
    const category = usagerCategories.find(cat => parseInt(cat.id_export, 10) === codeNum);
    return category ? category.name : `Activité ${code}`;
  })()}
</Badge>

                                  </td>
                                  <td className="text-center">
                                    <Badge bg="primary" pill className="px-3 py-2">
                                      {c.nombre_taxes_categorie || 0}
                                    </Badge>
                                  </td>
                                  <td className="text-center">
                                    <Badge bg="secondary" pill className="px-3 py-2">
                                      {c.nombre_echeances || 0}
                                    </Badge>
                                  </td>
                                  <td>
                                    <span className="fw-semibold text-primary">
                                      {formatCurrency(c.montant_total_categorie)}
                                    </span>
                                  </td>
                                  <td>
                                    <span className="text-success">
                                      {formatCurrency(c.montant_paye_categorie)}
                                    </span>
                                    {c.montant_restant_categorie > 0 && (
                                      <div className="small text-danger">
                                        Reste: {formatCurrency(c.montant_restant_categorie)}
                                      </div>
                                    )}
                                  </td>
                                  <td className="text-center" style={{ width: '100px' }}>
                                    <div className="d-flex align-items-center gap-2">
                                      <ProgressBar 
                                        now={c.taux_paiement} 
                                        variant={getRecoveryVariant(c.taux_paiement)} 
                                        style={{ height: '6px', width: '70px' }}
                                      />
                                      <small>{c.taux_paiement.toFixed(0)}%</small>
                                    </div>
                                  </td>
                                  {/* <td>
                                    {c.is_active === 1 ? (
                                      <Badge bg="success" pill className="px-3 py-2">
                                        <CheckCircle className="me-1" size={10} /> Actif
                                      </Badge>
                                    ) : (
                                      <Badge bg="secondary" pill className="px-3 py-2">
                                        <XCircle className="me-1" size={10} /> Inactif
                                      </Badge>
                                    )}
                                  </td> */}
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>

                        {contribuableTotalPages > 1 && (
                          <div className="d-flex justify-content-center mt-4">
                            <Pagination size="sm">
                              <Pagination.Prev disabled={contribuableCurrentPage === 1} onClick={() => setContribuableCurrentPage(p => p - 1)} />
                              {[...Array(Math.min(5, contribuableTotalPages))].map((_, i) => {
                                let pageNum = i + 1;
                                if (contribuableCurrentPage > 3 && contribuableTotalPages > 5) {
                                  pageNum = contribuableCurrentPage - 2 + i;
                                  if (pageNum > contribuableTotalPages) return null;
                                }
                                return (
                                  <Pagination.Item key={pageNum} active={pageNum === contribuableCurrentPage} onClick={() => setContribuableCurrentPage(pageNum)}>
                                    {pageNum}
                                  </Pagination.Item>
                                );
                              })}
                              <Pagination.Next disabled={contribuableCurrentPage === contribuableTotalPages} onClick={() => setContribuableCurrentPage(p => p + 1)} />
                            </Pagination>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </Tab>

                <Tab 
                  eventKey="activities" 
                  title={
                    <span>
                      <Folder className="me-2" size={16} />
                      Activités ({professionnelActivities.length})
                    </span>
                  }
                >
                  <div className="p-4">
                    <div className="mb-4" style={{ maxWidth: '400px' }}>
                      <InputGroup>
                        <InputGroup.Text><Search size={16} /></InputGroup.Text>
                        <Form.Control
                          placeholder="Rechercher une activité..."
                          value={professionnelFilterText}
                          onChange={(e) => setProfessionnelFilterText(e.target.value)}
                        />
                      </InputGroup>
                    </div>

                    {loadingUsagerCategories ? (
                      <div className="text-center py-5">
                        <Spinner animation="border" variant="primary" />
                        <p className="mt-3 text-muted">Chargement des activités...</p>
                      </div>
                    ) : paginatedProfessionnelActivities.length === 0 ? (
                      <div className="text-center py-5">
                        <Folder size={48} className="text-muted mb-3 opacity-25" />
                        <h5>Aucune activité trouvée</h5>
                        <p className="text-muted">
                          {professionnelFilterText ? "Aucune activité ne correspond à votre recherche" : "Aucune activité professionnelle n'est associée aux contribuables"}
                        </p>
                      </div>
                    ) : (
                      <>
                        <div className="table-responsive">
                          <Table hover className="align-middle">
                            <thead className="table-light">
                              <tr>
                                <th>Code</th>
                                <th>Intitulé de l'activité</th>
                                <th>Description</th>
                                <th className="text-center">Contribuables</th>
                                <th className="text-center">Échéances</th>
                                <th>Montant total</th>
                                <th>Payé</th>
                                <th className="text-center">Taux</th>
                              </tr>
                            </thead>
                            <tbody>
                              {paginatedProfessionnelActivities.map((activity, index) => (
                                <tr key={index}>
                                  <td>
                                    <Badge bg="primary" pill className="px-3 py-2">
                                      {activity.code}
                                    </Badge>
                                  </td>
                                  <td>
                                    <div className="fw-semibold">{activity.nom}</div>
                                  </td>
                                  <td>
                                    <small className="text-muted">
                                      {activity.description?.substring(0, 60) || '-'}
                                      {activity.description?.length > 60 ? '...' : ''}
                                    </small>
                                  </td>
                                  <td className="text-center">
                                    <Badge bg="info" pill className="px-3 py-2">
                                      <People className="me-1" size={12} />
                                      {formatNumber(activity.nombreContribuables)}
                                    </Badge>
                                  </td>
                                  <td className="text-center">
                                    <Badge bg="secondary" pill className="px-3 py-2">
                                      <Receipt className="me-1" size={12} />
                                      {formatNumber(activity.nombreEcheances)}
                                    </Badge>
                                  </td>
                                  <td>
                                    <span className="fw-bold text-primary">
                                      {formatCurrency(activity.montantTotal)}
                                    </span>
                                  </td>
                                  <td>
                                    <span className="text-success">
                                      {formatCurrency(activity.montantPaye)}
                                    </span>
                                  </td>
                                  <td style={{ minWidth: '120px' }}>
                                    <div className="d-flex align-items-center gap-2">
                                      <ProgressBar 
                                        now={activity.tauxPaiement} 
                                        variant={getRecoveryVariant(activity.tauxPaiement)} 
                                        style={{ height: '6px', width: '80px' }}
                                      />
                                      <small className="fw-semibold">{activity.tauxPaiement.toFixed(1)}%</small>
                                    </div>
                                   </td>
                                 </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>

                        {professionnelTotalPages > 1 && (
                          <div className="d-flex justify-content-center mt-4">
                            <Pagination size="sm">
                              <Pagination.Prev disabled={professionnelCurrentPage === 1} onClick={() => setProfessionnelCurrentPage(p => p - 1)} />
                              {[...Array(Math.min(5, professionnelTotalPages))].map((_, i) => {
                                let pageNum = i + 1;
                                if (professionnelCurrentPage > 3 && professionnelTotalPages > 5) {
                                  pageNum = professionnelCurrentPage - 2 + i;
                                  if (pageNum > professionnelTotalPages) return null;
                                }
                                return (
                                  <Pagination.Item key={pageNum} active={pageNum === professionnelCurrentPage} onClick={() => setProfessionnelCurrentPage(pageNum)}>
                                    {pageNum}
                                  </Pagination.Item>
                                );
                              })}
                              <Pagination.Next disabled={professionnelCurrentPage === professionnelTotalPages} onClick={() => setProfessionnelCurrentPage(p => p + 1)} />
                            </Pagination>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </Tab>

                <Tab 
                  eventKey="timeline" 
                  title={
                    <span>
                      <ClockHistory className="me-2" size={16} />
                      Timeline ({filteredActivities.length})
                    </span>
                  }
                >
                  <div className="p-4">
                    <div className="d-flex gap-3 mb-4">
                      <InputGroup style={{ maxWidth: '300px' }}>
                        <InputGroup.Text><Search size={16} /></InputGroup.Text>
                        <Form.Control
                          placeholder="Rechercher..."
                          value={taxFilterText}
                          onChange={(e) => setTaxFilterText(e.target.value)}
                        />
                      </InputGroup>
                      <Form.Select
                        style={{ width: '180px' }}
                        value={activityFilter}
                        onChange={(e) => setActivityFilter(e.target.value)}
                      >
                        <option value="all">Toutes les activités</option>
                        <option value="echeance">Échéances</option>
                        <option value="paiement">Paiements</option>
                        <option value="alerte">Alertes</option>
                      </Form.Select>
                    </div>

                    {loadingActivities ? (
                      <div className="text-center py-5">
                        <Spinner animation="border" variant="primary" />
                        <p className="mt-3 text-muted">Chargement des activités...</p>
                      </div>
                    ) : filteredActivities.length === 0 ? (
                      <div className="text-center py-5">
                        <Activity size={48} className="text-muted mb-3 opacity-25" />
                        <h5>Aucune activité</h5>
                        <p className="text-muted">Aucune activité pour les contribuables de cette catégorie</p>
                      </div>
                    ) : (
                      <>
                        <div className="timeline">
                          {paginatedActivities.map((activity, index) => {
                            const IconComponent = activity.icon;
                            return (
                              <div className="timeline-item" key={activity.id || index}>
                                <div className={`timeline-marker bg-${activity.color}`} />
                                <div className="timeline-content">
                                  <div className="d-flex justify-content-between align-items-start flex-wrap gap-2">
                                    <div className="d-flex align-items-center">
                                      <div className={`bg-${activity.color} bg-opacity-10 p-2 rounded-circle me-3`}>
                                        <IconComponent className={`text-${activity.color}`} size={18} />
                                      </div>
                                      <div>
                                        <h6 className="mb-1 fw-semibold">{activity.title}</h6>
                                        <p className="text-muted small mb-0">{activity.description}</p>
                                      </div>
                                    </div>
                                    <div className="text-end">
                                      <small className="text-muted d-block">{formatDate(activity.date)}</small>
                                      <small className="text-muted">{formatRelativeTime(activity.date)}</small>
                                    </div>
                                  </div>

                                  {activity.montant > 0 && (
                                    <div className="mt-3 pt-2 border-top">
                                      <div className="d-flex gap-3">
                                        <div>
                                          <small className="text-muted">Montant</small>
                                          <div className="fw-bold text-primary">{formatCurrency(activity.montant)}</div>
                                        </div>
                                        {activity.montantPaye > 0 && (
                                          <div>
                                            <small className="text-muted">Payé</small>
                                            <div className="fw-bold text-success">{formatCurrency(activity.montantPaye)}</div>
                                          </div>
                                        )}
                                        {activity.reste > 0 && (
                                          <div>
                                            <small className="text-muted">Reste</small>
                                            <div className="fw-bold text-danger">{formatCurrency(activity.reste)}</div>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  )}

                                  <div className="d-flex flex-wrap gap-2 mt-3">
                                    {activity.badges?.map((badge, i) => (
                                      <Badge key={i} bg={badge.bg} className="px-2 py-1">
                                        {badge.text}
                                      </Badge>
                                    ))}
                                    {activity.contribuable && (
                                      <Badge 
                                        bg="light" 
                                        text="dark" 
                                        className="px-2 py-1"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => navigate(`/agent/ContribuableDetails/${activity.contribuable.contribuable_id}`)}
                                      >
                                        <Person className="me-1" size={10} />
                                        {activity.contribuable.nom_contribuable}
                                      </Badge>
                                    )}
                                    {activity.reference && (
                                      <Badge bg="light" text="dark" className="px-2 py-1">
                                        Ref: {activity.reference}
                                      </Badge>
                                    )}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>

                        {activityTotalPages > 1 && (
                          <div className="d-flex justify-content-center mt-4">
                            <Pagination size="sm">
                              <Pagination.Prev disabled={activityPage === 1} onClick={() => setActivityPage(p => p - 1)} />
                              {[...Array(Math.min(5, activityTotalPages))].map((_, i) => {
                                let pageNum = i + 1;
                                if (activityPage > 3 && activityTotalPages > 5) {
                                  pageNum = activityPage - 2 + i;
                                  if (pageNum > activityTotalPages) return null;
                                }
                                return (
                                  <Pagination.Item key={pageNum} active={pageNum === activityPage} onClick={() => setActivityPage(pageNum)}>
                                    {pageNum}
                                  </Pagination.Item>
                                );
                              })}
                              <Pagination.Next disabled={activityPage === activityTotalPages} onClick={() => setActivityPage(p => p + 1)} />
                            </Pagination>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </Tab>
              </Tabs>
            </Card.Header>
          </Card>
        </div>
         <Footer />
      </div>

      {/* Modal d'édition */}
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered>
        <Modal.Header closeButton className="bg-primary text-white">
          <Modal.Title><Pencil className="me-2" size={18} /> Modifier la catégorie</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label className="fw-semibold">Nom de la catégorie</Form.Label>
              <Form.Control
                type="text"
                value={editedCategory?.category_name || ''}
                onChange={(e) => setEditedCategory({ ...editedCategory, category_name: e.target.value })}
                placeholder="Ex: Taxe foncière"
              />
            </Form.Group>
            <Form.Group>
              <Form.Label className="fw-semibold">Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={editedCategory?.category_descr || ''}
                onChange={(e) => setEditedCategory({ ...editedCategory, category_descr: e.target.value })}
                placeholder="Description de la catégorie (optionnelle)"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEditModal(false)}>
            <X className="me-2" size={14} /> Annuler
          </Button>
          <Button variant="primary" onClick={handleSaveEdit} disabled={loadingUpdate}>
            {loadingUpdate ? <Spinner size="sm" className="me-2" /> : <Save className="me-2" size={14} />}
            Enregistrer
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal d'ajout de taxe */}
      <Modal show={showAddTaxModal} onHide={() => setShowAddTaxModal(false)} size="lg" centered>
        <Modal.Header closeButton className="bg-success text-white">
          <Modal.Title><PlusCircle className="me-2" size={18} /> Nouvelle taxe</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row className="g-3">
              <Col md={12}>
                <Form.Group>
                  <Form.Label className="fw-semibold">Catégorie</Form.Label>
                  <Form.Control type="text" value={category?.category_name} disabled className="bg-light" />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="fw-semibold">Titre de la taxe *</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Ex: Taxe professionnelle"
                    value={newTax.titre}
                    onChange={(e) => setNewTax({...newTax, titre: e.target.value})}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="fw-semibold">Montant *</Form.Label>
                  <InputGroup>
                    <Form.Control
                      type="number"
                      placeholder="Montant"
                      value={newTax.montant}
                      onChange={(e) => setNewTax({...newTax, montant: e.target.value})}
                    />
                    <InputGroup.Text>{defaultCurrency}</InputGroup.Text>
                  </InputGroup>
                </Form.Group>
              </Col>
              <Col md={12}>
                <Form.Group>
                  <Form.Label className="fw-semibold">Fréquence</Form.Label>
                  <Form.Select
                    value={newTax.frequence}
                    onChange={(e) => setNewTax({...newTax, frequence: e.target.value})}
                  >
                    {Object.entries(frequencies).map(([key, label]) => (
                      <option key={key} value={key}>{frequencyIcons[key]} {label}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={12}>
                <Form.Group>
                  <Form.Label className="fw-semibold">Description (optionnelle)</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    placeholder="Description de la taxe"
                    value={newTax.description}
                    onChange={(e) => setNewTax({...newTax, description: e.target.value})}
                  />
                </Form.Group>
              </Col>
              <Col md={12}>
                <Form.Check
                  type="switch"
                  id="tax-active-switch"
                  label="Taxe active"
                  checked={newTax.actif}
                  onChange={(e) => setNewTax({...newTax, actif: e.target.checked})}
                />
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowAddTaxModal(false)}>
            <X className="me-2" size={14} /> Annuler
          </Button>
          <Button variant="success" onClick={handleAddTax} disabled={loadingAddTax || !newTax.titre || !newTax.montant}>
            {loadingAddTax ? <Spinner size="sm" className="me-2" /> : <Check className="me-2" size={14} />}
            Créer la taxe
          </Button>
        </Modal.Footer>
      </Modal>

      <style>{`
        .stats-card {
          transition: all 0.3s ease;
          border-radius: 16px;
        }
        .stats-card:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 25px rgba(0,0,0,0.1) !important;
        }
        .spin {
          animation: spin 1s linear infinite;
        }
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        .timeline {
          position: relative;
          padding-left: 30px;
        }
        .timeline::before {
          content: '';
          position: absolute;
          left: 15px;
          top: 0;
          bottom: 0;
          width: 2px;
          background: #e9ecef;
        }
        .timeline-item {
          position: relative;
          margin-bottom: 1.5rem;
        }
        .timeline-marker {
          position: absolute;
          left: -30px;
          top: 5px;
          width: 12px;
          height: 12px;
          border-radius: 50%;
          border: 2px solid white;
          box-shadow: 0 0 0 2px #e9ecef;
          z-index: 1;
        }
        .timeline-content {
          background: white;
          padding: 1rem;
          border-radius: 12px;
          border: 1px solid #e9ecef;
          transition: all 0.2s ease;
        }
        .timeline-content:hover {
          box-shadow: 0 4px 12px rgba(0,0,0,0.08);
        }
        .table tbody tr {
          transition: all 0.2s ease;
        }
        .table tbody tr:hover {
          background-color: #f8fbff;
        }
        .nav-tabs .nav-link {
          border: none;
          border-radius: 8px;
          padding: 10px 20px;
          color: #6c757d;
          font-weight: 500;
          transition: all 0.2s;
        }
        .nav-tabs .nav-link:hover {
          background-color: #e9ecef;
          color: #0d6efd;
        }
        .nav-tabs .nav-link.active {
          background-color: #0d6efd;
          color: white;
        }
        .page-link {
          border-radius: 8px;
          margin: 0 2px;
          color: #0d6efd;
        }
        .page-item.active .page-link {
          background-color: #0d6efd;
          border-color: #0d6efd;
        }
      `}</style>

     
    </>
  );
}